import Cookies from 'cookies-js';

export class CookiesSettings {
    constructor(param = "unnamedParam"){
        this.mainField = "settings"
        this.settings = this.getSettings()
        this.param = param
        this.data = this.getData()
    }
    getSettings(){
        let settingsCookie = Cookies.get(this.mainField);
        if(settingsCookie){
            return JSON.parse(settingsCookie)
        }
        return null;
    }
    getData(){
        if(this.settings){
            let data = this.settings[this.param];
            return data;
        }
        return null;
    }
    set(field,value){
        this.data = {
            ...this.data,
            [field]:value
        }

        this.settings ={
            ...this.settings,
            [this.param]:this.data
        }
        Cookies.set(this.mainField,
            JSON.stringify(this.settings)
        )
    }
    get(field){
        if(this.data){
            return(
                this.data[field]
            )
        }
        return null
    }

}


// WEBPACK FOOTER //
// ./src/helpers/cookiesHelper.js